const sessionHelper = {
  clearUserSessions: () => {
    const prefixToRemove = 'filter_NC_';
    const prefixCToRemove = 'filter_C_';
    const prefixLastToRemove = 'lastSelected';

    //variables of filter NC list
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);

      if (
        key &&
        (key.startsWith(prefixToRemove) || key.startsWith(prefixCToRemove))
      ) {
        sessionStorage.removeItem(key);
      }
    }

    //variables from the last NC record
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);

      if (key && key.startsWith(prefixLastToRemove)) {
        sessionStorage.removeItem(key);
      }
    }

    //others
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('siteId');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('sessionExpiration');
    sessionStorage.removeItem('countIotsNcsOpened');
    sessionStorage.removeItem('tbIssuesSearch');
  },
};

export default sessionHelper;
